"use strict";

// these go away when we get actual html libraries in here to parse stuff. god willing.
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeImgTags = exports.decodeHtmlStringIntoString = exports.encodeStringIntoHtmlString = exports.stylesObjectToString = exports.getInlineStylesForOpeningTag = void 0;
const getInlineStylesForOpeningTag = element => {
  const inlineStyles = new Map();
  const STYLE_REGEX = /(style="([^"]*))"/g;
  const inlineStyle = STYLE_REGEX.exec(element);
  if (inlineStyle) {
    const styles = inlineStyle[2].split(';');
    styles.forEach(nameValue => {
      const nameAndValue = nameValue.split(':');
      if (nameAndValue.length == 2) {
        inlineStyles.set(nameAndValue[0].trim(), nameAndValue[1].trim());
      }
    });
  }
  return inlineStyles;
};
exports.getInlineStylesForOpeningTag = getInlineStylesForOpeningTag;
const stylesObjectToString = stylesObject => {
  let styles = '';
  stylesObject.forEach((cssValuevalue, cssName) => {
    styles += `${cssName}: ${cssValuevalue}; `;
  });
  if (styles) {
    styles = styles.substring(0, styles.length - 1);
  }
  return styles;
};
exports.stylesObjectToString = stylesObjectToString;
const encodeStringIntoHtmlString = string => {
  return string.replace(/&/g, '&amp;').replace(/(<[^>]*>)|</g, (match, group) => group ? group : '&lt;').replace(/(<[^>]*>)|>/g, (match, group) => group ? group : '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};
exports.encodeStringIntoHtmlString = encodeStringIntoHtmlString;
const decodeHtmlStringIntoString = string => {
  return string.replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').replace(/&quot;/gi, '"').replace('&#39;', '\'');
};
exports.decodeHtmlStringIntoString = decodeHtmlStringIntoString;
const removeImgTags = string => {
  return string.replace(/<img.*?>/gi, '');
};
exports.removeImgTags = removeImgTags;